import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { formatDate, formatDateTime, formatMonth, formatTime, parseIsoDate } from '../lib/dates'

/**
 * Date formatters bound to the current language's month names: "10 Nov 2026",
 * "10 Nov 2026, 08:00", "Nov 2026". `formatDay` and `formatMoment` take the API's ISO strings.
 */
export function useDateFormat() {
  const { t } = useTranslation()
  return useMemo(() => {
    const months = t('dates.monthsShort', { returnObjects: true }) as readonly string[]
    return {
      monthsShort: months,
      formatDate: (date: Date) => formatDate(date, months),
      formatDateTime: (date: Date) => formatDateTime(date, months),
      formatTime,
      /** "2026-11-10" → "10 Nov 2026". */
      formatDay: (iso: string) => formatDate(parseIsoDate(iso), months),
      /** "2026-11-10T08:00:00+02:00" → "10 Nov 2026, 08:00". */
      formatMoment: (iso: string) => formatDateTime(new Date(iso), months),
      /** "2026-11" → "Nov 2026". */
      formatMonth: (iso: string) => formatMonth(iso, months),
    }
  }, [t])
}
